const Fallback = () => {
  return (
    <div className="w-full bg-white flex items-center justify-center py-4">
      <div>Loading...</div>
    </div>
  );
};

export default Fallback;
